/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type StorefrontFeaturedSection_products = {
    readonly " $fragmentRefs": FragmentRefs<"StorefrontProductGrid_products">;
    readonly " $refType": "StorefrontFeaturedSection_products";
};
export type StorefrontFeaturedSection_products$data = StorefrontFeaturedSection_products;
export type StorefrontFeaturedSection_products$key = {
    readonly " $data"?: StorefrontFeaturedSection_products$data;
    readonly " $fragmentRefs": FragmentRefs<"StorefrontFeaturedSection_products">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "StorefrontFeaturedSection_products",
  "type": "DealerStorefrontQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "StorefrontProductGrid_products",
      "args": null
    }
  ]
};
(node as any).hash = '2d2c8610c5ed41f25743180021d9d7ec';
export default node;
